import { useMemo } from "react";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";

import { registry } from "../../../configs/registry";
import { useGlobalStore } from "../../utils/useGlobalStore/useGlobalStore";

export const useLayout = () => {
  const { headerFooterConfig, applicationId } = useGlobalStore();
  const { isWebView } = useEnvironment();

  return useMemo(() => {
    const layoutMode = isWebView
      ? "hidden"
      : ((applicationId && registry.getApplicationFromId(applicationId))
          ?.layout ?? "full");

    return {
      headerFooterConfig,
      layoutMode,
    };
  }, [applicationId, isWebView, headerFooterConfig]);
};
